import React from "react";
import autoBind from "react-autobind";
import { Pagination } from "react-bootstrap";

class PaginationComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startPage: 1,
      lastPage: 8,
      itemsPerPage: 8,
      totalPages: 8,
    };

    this.itemsPerPage = 8;
    this.startPage = 1;
    this.endPage = 0;

    autoBind(this);
  }

  calcTotalPages() {
    this.totalPages = Math.ceil(this.props.pageCount / this.props.pageSize);

    if (this.props.pageNumber >= this.totalPages) {
      const pageNumber = this.totalPages;
      if (this.pageModified) {
        if (this.totalPages != this.pageModified) {
          this.props.setStateAndRefresh({ pageNumber });
          this.pageModified = this.totalPages;
        }
      } else {
        this.pageModified = this.totalPages;
      }
    }
  }

  get isPrevDisabled() {
    return this.props.pageCount == 0 || this.props.pageNumber == 1;
  }

  get isFirstDisabled() {
    return this.props.pageCount == 0 || this.props.pageNumber == 1;
  }

  get isNextDisabled() {
    return this.props.pageCount == 0 || this.props.pageNumber == this.totalPages;
  }

  get isLastDisabled() {
    return this.props.pageCount == 0 || this.props.pageNumber == this.totalPages;
  }

  isActive(page) {
    return this.props.pageNumber == page;
  }

  hasMoreBack() {
    return this.startPage > 1;
  }

  hasMoreNext() {
    return this.endPage < this.totalPages;
  }

  updateCurrentPage(page) {
    this.props.onChange(page);
  }

  getPages() {
    let maxSize = this.state.itemsPerPage;
    let pages = [];
    // Default page limits
    let startPage = 1,
      endPage = this.totalPages;
    const isMaxSized = maxSize < this.totalPages;
    // recompute if maxSize
    if (isMaxSized) {
      // Visible pages are paginated with maxSize
      const startPageCurrent = (Math.ceil(this.props.pageNumber / maxSize) - 1) * maxSize + 1;
      if (startPageCurrent < 0) {
        startPage = 1
        this.updateCurrentPage(1)
      }
      else {
        startPage = startPageCurrent
      }
      // Adjust last page if limit is exceeded
      endPage = Math.min(startPage + maxSize - 1, this.totalPages);
    }
    // Add page number links
    for (let number = startPage; number <= endPage; number++) {
      pages.push(number);
    }

    this.startPage = startPage;
    this.endPage = endPage;
    return pages;
  }

  onClickFirst() {
    this.updateCurrentPage(1);
  }

  onClickPrevious() {
    this.updateCurrentPage(this.props.pageNumber - 1);
  }

  onClickMoreBack() {
    this.updateCurrentPage(this.startPage - 1);
  }

  onClickPage(page) {
    return () => {
      this.updateCurrentPage(page);
    };
  }

  onClickNext() {
    this.updateCurrentPage(this.props.pageNumber + 1);
  }

  onClickMoreNext() {
    this.updateCurrentPage(this.endPage + 1);
  }

  onClickLast() {
    this.updateCurrentPage(this.totalPages);
  }

  render() {
    const { pageSize, pageCount, onPageSizeChange, hasPagination, hidBarPagination } = this.props;
    this.calcTotalPages();
    return (
      <div className="container-nav">
        {!hidBarPagination &&
          <nav className="nav-pagination">
            <div className="clearfix">
              {hasPagination && (
                <Pagination className="float-left">
                  <Pagination.Item disabled={this.isFirstDisabled} onClick={this.onClickFirst} title={"Primeiro"}>
                    Primeiro
                  </Pagination.Item>
                  <Pagination.Item disabled={this.isPrevDisabled} onClick={this.onClickPrevious} title={"Anterior"}>
                    Anterior
                  </Pagination.Item>
                  {this.hasMoreBack() && <Pagination.Ellipsis onClick={this.onClickMoreBack} title={"Voltar Páginas"} />}
                  {this.getPages().map((page) => (
                    <Pagination.Item
                      active={this.isActive(page)}
                      onClick={this.onClickPage(page)}
                      key={page}
                      title={`Página ${page}`}
                    >
                      {page}
                    </Pagination.Item>
                  ))}
                  {this.hasMoreNext() && <Pagination.Ellipsis onClick={this.onClickMoreNext} title={"Avançar Páginas"} />}
                  <Pagination.Item disabled={this.isNextDisabled} onClick={this.onClickNext} title={"Próximo"}>
                    Próximo
                  </Pagination.Item>
                  <Pagination.Item disabled={this.isLastDisabled} onClick={this.onClickLast} title={"Último"}>
                    Último
                  </Pagination.Item>
                  <select
                    className="page-size"
                    ng-model="pageSize"
                    onChange={onPageSizeChange}
                    value={pageSize}
                    title={"Registros por Página"}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </Pagination>
              )}
              <div className="float-right">
                {hasPagination && (
                  <p>
                    <span>Páginas: {this.totalPages} </span>
                  </p>
                )}
                <p>
                  <span>Total de Registros: {pageCount} </span>
                </p>
              </div>
            </div>
          </nav>
        }
      </div>
    );
  }
}

export default PaginationComponent;
